module.exports = __webpack_public_path__ + "media/images/recruit/position/banner_engineer_wanted-150667b681abbfe1e15fc3de48972fd8.jpg";